(() => {
    tinymce.PluginManager.add('materialicon', function(editor, url) {
        editor.addButton('materialicon', {
            text:'Ícone',
            tooltip: 'Inserir ícone',
            onclick: () => iconWindow()
        })

        function iconWindow(callbackFunction = false) {
            editor.windowManager.open({
                title: 'Inserir ícone',
                url: '/admin/icon-manager',
                width: 800,
                height: 600,
                buttons: [
                    {
                        text: 'Inserir',
                        subtype: 'primary',
                        onclick: function() {
                            let icon = tinymce.activeEditor.selectedIcon

                            if(! icon) {
                                return
                            }

                            editor.insertContent(`<i class="material-icons">${icon.icon_class}</i>`)
                            editor.windowManager.close()
                        }
                    },
                    {
                        text: 'Fechar',
                        onclick: 'close'
                    }
                ]
            })
        }
    })
})()
